import axios from "axios";
import { store } from "@/store";

// Stripe API Base URL through proxy
const STRIPE_API_BASE_URL =
  import.meta.env.VITE_STRIPE_API_BASE_URL || "/api/stripe";

const stripeApiClient = axios.create({
  baseURL: STRIPE_API_BASE_URL,
  withCredentials: true, // Crucial for sending cookies
});

// Interceptor pour ajouter la langue dans les headers de chaque requête
stripeApiClient.interceptors.request.use(
  (config) => {
    // Récupérer la langue courante depuis Redux store
    const state = store.getState();
    const language = state.settings.language;

    if (language) {
      config.headers["Accept-Language"] = language;
      config.headers["X-User-Language"] = language;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add interceptors for global error handling
stripeApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized access to Stripe API");
    }

    // Extract and preserve specific error messages from API responses
    if (error.response?.data?.error) {
      // Create a new error with the specific message from the API
      const apiError = new Error(error.response.data.error);
      apiError.name = "StripeAPIError";
      // Preserve original status and response data
      (apiError as any).status = error.response.status;
      (apiError as any).response = error.response;
      return Promise.reject(apiError);
    }

    return Promise.reject(error);
  },
);

export default stripeApiClient;
